import { render, staticRenderFns } from "./MagList.vue?vue&type=template&id=105c4c34&"
import script from "./MagList.vue?vue&type=script&lang=js&"
export * from "./MagList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports